// "Log renewal": open All Sales → New Sale pre-filled for this member (status = Renewal).
// Shared by the Up for renewal tab and the member detail panel (CR-0074).
export function logRenewal({ name, phone, programme } = {}) {
  const params = new URLSearchParams();
  if (name) params.set("member_name", name);
  if (phone) params.set("customer_phone", phone);
  if (programme) params.set("programme", programme);
  params.set("status", "Renewal");
  window.location.href = `/sales-log?${params.toString()}`;
}
